import { PageHeader } from "@/components/page-header";
import { CsvImporter } from "@/components/csv-importer";

type Row = { name?: string; company?: string; email?: string; phone?: string; source?: string; linkedinUrl?: string; notes?: string };

const FIELD_MAP: Record<string, keyof Row> = {
  name: "name", "full name": "name",
  company: "company", organization: "company",
  email: "email", "email address": "email",
  phone: "phone",
  source: "source", "lead source": "source",
  linkedin: "linkedinUrl", "linkedin url": "linkedinUrl",
  notes: "notes",
};

export default function LeadImportPage() {
  return (
    <>
      <PageHeader title="Import Leads" description="CSV headers: name, company, email, phone, source, linkedin, notes." />
      <CsvImporter<Row>
        module="Leads"
        endpoint="/leads/bulk-import"
        backTo="/leads"
        listQueryKey={["/leads"]}
        fieldMap={FIELD_MAP}
        requiredField="name"
        description="Dedupes by email + LinkedIn URL. Max 1000 per upload."
        previewColumns={[
          { field: "name", label: "Name" },
          { field: "company", label: "Company" },
          { field: "email", label: "Email" },
          { field: "source", label: "Source" },
        ]}
      />
    </>
  );
}
